import { render } from "./Step1AssignThermostat.vue?vue&type=template&id=d229993e&ts=true"
import script from "./Step1AssignThermostat.ts?vue&type=script&lang=ts"
export * from "./Step1AssignThermostat.ts?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/Frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__